import { assetsClipEditCaptionsCreate, assetsClipUpdate, ClipAssetResponse } from '@goldcast/api/content';
import { DEFAULT_AUDIO_CONTENT_MAGIC_LAYOUT, DEFAULT_MAGIC_LAYOUT } from '../constants/clip-defaults';
import { Clip } from '../types/clip-types';
import { isClipAudioContent, isClipFromUploads } from '../utils/clipUtils';

function transformClipResponse(clip: ClipAssetResponse): any {
  const isAudio = isClipAudioContent(clip as Clip);
  return {
    ...(clip ?? {}),
    id: clip.id,
    event: clip.content!.project.id,
    broadcast: clip.content!.id,
    organization: clip.asset_metadata.organization,
    title: clip.title,
    broadcast_data: {
      title: clip.content!.title
    },
    asset_metadata: {
      ...(isClipFromUploads(clip as Clip) && {
        magicLayout: isAudio ? DEFAULT_AUDIO_CONTENT_MAGIC_LAYOUT : DEFAULT_MAGIC_LAYOUT
      }),
      ...clip.asset_metadata
    },
    rating: clip.rating,
    isRemoved: false,
    layout_status: clip.layout_status,
    shared: clip.shared,
    updated_at: clip.updated_at
  };
}

export function updateClip(clip: Clip): Promise<any> {
  const modifiedClip = { ...clip, asset_metadata: { ...clip.asset_metadata } };
  modifiedClip.asset_metadata.config = null;

  return assetsClipUpdate({
    id: modifiedClip.id,
    body: modifiedClip
  }).then(transformClipResponse);
}

export function updateTranslatedCaption(clip: Clip): Promise<any> {
  return assetsClipEditCaptionsCreate({
    body: {
      asset_id: clip.id,
      target_language: clip?.asset_metadata?.selected_lang ?? 'en',
      translation_metadata: {
        edits: clip.asset_metadata.edits,
        merges: clip.asset_metadata?.merges ?? []
      }
    }
  }).then(transformClipResponse);
}
